import React, { useState } from "react";
import { maintenanceApi, VehicleCompany } from "../../../api/maintenance";
import { X } from "lucide-react";
import { useNotice } from "../shared/useNotice";

interface Props {
  editingCompany: VehicleCompany | null;
  onClose: () => void;
  onDone: () => void;
}

const VehicleCompanyForm: React.FC<Props> = ({ editingCompany, onClose, onDone }) => {
  const isEdit = !!editingCompany;
  const [name, setName] = useState(editingCompany?.name || "");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useNotice("error", "");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!name.trim()) {
      setError("Company name is required");
      return;
    }
    setSubmitting(true);
    setError("");
    try {
      if (isEdit && editingCompany) {
        await maintenanceApi.updateVehicleCompany(editingCompany.id, { name: name.trim() });
      } else {
        await maintenanceApi.createVehicleCompany({ name: name.trim() });
      }
      onDone();
    } catch (err: any) {
      setError(err?.response?.data?.detail || "Failed to save company");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="maint-form-overlay">
      <div className="maint-form-card maint-form-card--narrow">
        <div className="maint-form-header">
          <h3>{isEdit ? "Edit" : "Add"} Vehicle Company</h3>
          <button onClick={onClose} className="maint-btn-icon"><X size={18} /></button>
        </div>
        <form onSubmit={handleSubmit}>
          <label>
            Company name *
            <input
              type="text"
              value={name}
              autoFocus
              maxLength={512}
              placeholder="e.g. Tata Motors"
              onChange={(e) => setName(e.target.value)}
              required
            />
          </label>

          {error && <p className="maint-form-error">{error}</p>}
          <div className="maint-form-actions">
            <button type="button" onClick={onClose} className="maint-btn-secondary">Cancel</button>
            <button type="submit" disabled={submitting} className="maint-btn-primary">
              {submitting ? "Saving..." : isEdit ? "Update" : "Create"} Company
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default VehicleCompanyForm;
